export const referalIncomesPagination = {
  namespaced: true,
  state: () => ({
    paginationReferalIncomesParams: {
      count: 0,
      limit: 100,
      total: 0,
      page: 0
    }
  }),

  getters: {
    numPages: (state) =>
      Math.ceil(
        state.paginationReferalIncomesParams.total /
        state.paginationReferalIncomesParams.limit
      )
  },
  mutations: {
    update_pagination(state, { total, count, limit, page }) {
      state.paginationReferalIncomesParams = { total, count, limit, page }
    }
  },
  actions: {
    getIncomesAll({ commit }, pagination) {
      commit('update_pagination', pagination)
    }
  }
}
